// extracted by mini-css-extract-plugin
export default {"formHeading":"aH-z","form":"bH-z","submitBtn":"cH-z","disabled":"dH-z","input":"eH-z","error":"fH-z","submitMsg":"gH-z","signIn":"hH-z"};